export class SubAssunto {
    idSubAssunto: any;
    codSubAssunto: any;
    dsSubAssunto:any;
    flAtivo: any;

    constructor() {
        this.idSubAssunto = "";
        this.codSubAssunto = "";
        this.dsSubAssunto = "";
        this.flAtivo = "";
    }
}



// WEBPACK FOOTER //
// ./src/models/SubAssunto.ts